export default {
  // common
  ok: 'تأیید',
  cancel: 'لغو',
  send: 'ارسال',
  // time
  timeJustNow: 'همین الان',
  timeMinutesAgo: '{n} دقیقه پیش',
  timeHoursAgo: '{n} ساعت پیش',
  timeYesterday: 'دیروز',
  // chat toolbar titles
  chatEmotion: 'ایموجی',
  chatSendImage: 'ارسال تصویر',
  chatSendFile: 'ارسال فایل',
  chatReceipt: 'پیام رسید',
  chatSendVoice: 'ارسال صدا',
  chatGroupInfo: 'اطلاعات گروه',
  // chat area
  chatSomeoneAtMe: 'کسی مرا منشن کرد',
  chatNewMessages: '{n} پیام جدید',
  chatBackToBottom: 'بازگشت به پایین',
  chatReceiptPrefix: '[رسید] ',
  // message actions / tips
  chatNoMoreMessages: 'پیام بیشتری نیست',
  chatDeleteConfirm: 'این پیام حذف شود؟',
  chatDeleteTitle: 'حذف پیام',
  chatRecallConfirm: 'این پیام بازگردانده شود؟',
  chatRecallTitle: 'بازگرداندن پیام',
  chatRecalled: 'پیام بازگردانده شد',
  chatLocateFail: 'یافتن پیام اصلی ممکن نیست',
  chatResendUnsupported: 'این پیام از ارسال مجدد خودکار پشتیبانی نمی‌کند. لطفاً به‌صورت دستی مجدداً ارسال کنید.',
  // input disabled tips
  chatGroupDissolved: 'گروه منحل شده است',
  chatGroupQuit: 'شما دیگر در این گروه نیستید',
  chatGroupBanned: 'گروه مسدود شده است',
  chatUserBanned: 'این حساب مسدود شده است',
  chatBanReason: '، دلیل: ',
  // message status / readed
  msgReaded: 'خوانده شد',
  msgUnread: 'خوانده‌نشده',
  msgAllReaded: 'همه خواندند',
  msgSomeReaded: 'خوانده‌شده توسط {n}',
  msgSending: 'در حال ارسال',
  msgSendFail: 'ارسال ناموفق بود',
  msgRecall: 'تماس مجدد',
  msgMenuDelete: 'حذف',
  msgMenuRecall: 'بازگرداندن',
  // voice record
  recordTitle: 'ضبط صدا',
  recordDuration: 'مدت زمان',
  recordStart: 'شروع',
  recordPause: 'مکث',
  recordResume: 'ادامه',
  recordStop: 'توقف',
  recordPlay: 'پخش',
  recordStopPlay: 'توقف پخش',
  recordRestart: 'ضبط مجدد',
  recordSend: 'اکنون ارسال کن',
  recordStateReady: 'شروع نشده',
  recordStateRunning: 'در حال ضبط...',
  recordStatePaused: 'ضبط متوقف شد',
  recordStateStopped: 'ضبط پایان یافت',
  msgReadedTab: 'خوانده‌شده ({n})',
  msgUnreadTab: 'خوانده‌نشده ({n})',
  // language
  langLabel: 'زبان',
  langZh: '中文',
  langEn: 'English'
}
